import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Tier3 } from 'src/app/models/obs/tier3';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import { urlEndPoint } from 'src/app/common';
import { DptoService } from 'src/app/services/obs/dpto.service';
import { Dpto } from 'src/app/models/obs/dpto';
import { Message } from 'src/app/models/message';
import { LinkSector } from 'src/app/models/obs/linksector';
import { SectorService } from 'src/app/services/obs/sector.service';
import { Sector } from 'src/app/models/obs/sector';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';
import { Tier3Sector } from 'src/app/models/obs/tier3sector';
import { T3sectorService } from 'src/app/services/obs/t3sector.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Section } from 'src/app/models/obs/section';
import { SectionService } from 'src/app/services/obs/section.service';
import { Log } from 'src/app/models/user-log';
import { UtilLogService } from 'src/app/services/util/util-log.service';


@Component({
  selector: 'app-general-form',
  templateUrl: './general-form.component.html',
  styleUrl: './general-form.component.scss'
})
export class GeneralFormComponent implements OnInit {

  formT3: FormGroup;
  tier3: Tier3 = null;
  dptos: Dpto[] = [];
  sectors: Sector[] = [];
  linkSectors: LinkSector[] = [];
  msg: Message;

  edit: boolean = false;
  idtier1: string = null;
  uploatedFile: File = null;
  filename: string = '';
  isUploadDir: boolean = false;

  URL: string = urlEndPoint;
  paramsTier1: string = null;
  paramsId: string = null;
  tags: string = null;
  dataLog = {};

  sectordata: Sector[];
  movesLog: Log[] = null;
  codeValidationMessage: string | null = null;

  constructor(
    private secS: SectionService,
    private t3SectorService: T3sectorService,
    private errorService: ErrorHandlingService,
    private router: Router,
    private tier3Service: Tier3Service,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private uploadS: UploadfileService,
    private dptoService: DptoService,
    private sectorService: SectorService,
    private userLogService: UserLogService,
    private utilLogservice: UtilLogService,
    private tokenStorage: TokenStorageService,
    private tematicsService: TematicService
  ) { }

  ngOnInit() {
    this.createForm();
    this.paramsTier1 = this.activedRoute.snapshot.params['idtier1'];
    this.getTier3(this.activedRoute.snapshot.params);
    this.getTematics();
  }

  createForm() {
    this.formT3 = this.fb.group({
      id: [null],
      idtier1: [null],
      iddpto: [null],
      idsector: [null],
      idtematic: ['', Validators.required],
      code: [{ value: '', disabled: this.edit }, Validators.required],
      version: ['', Validators.required],
      shorttitle: ['', Validators.required],
      longtitle: ['', Validators.required],
      summary: ['', Validators.required],
      detail: [null],
      publication: ['', Validators.required],
      img: [null],
      urlfile: [null],
      lastUpdated: ['', Validators.required],
      status: [false],
      tags: [],
      sectors: this.fb.array([]),
      selectedSector: [null],
      isActive: [false],
      isNT3: [false],
      reviewedBy: [''],
      touchedBy: ['']
    })
  }

  getTier3(params: any) {
    if (params.id) {
      this.tier3Service.getOne(params.id).subscribe({
        next: res => {
          this.tier3 = res['data'];
          this.getLog();
          this.verifiedImgDirectory();
          this.loadData();
          this.edit = true;
          if (this.tier3.idtier1 == 12) {
            /* Tendencia territorial */
            this.getDptos();
          } else if (this.tier3.idtier1 == 13 || this.tier3.idtier1 == 5) {
            /* Tendencia sectorial */
            this.getSectors();
            this.getTier3Relations(params.id);
          }
        },
        error: err => console.error(err)
      });
    } else if (params.idtier1) {
      this.idtier1 = params.idtier1;
      this.edit = false;
      if (+this.idtier1 == 12) {
        /* Tendencia territorial */
        this.getDptos();
      } else if (+this.idtier1 == 13 || +this.idtier1 == 5) {
        /* Tendencia sectorial */
        this.getSectors();
        /* this.getTier3Relations(params.id); */
      }
    }
  }

  getDptos() {
    this.dptoService.getAll().subscribe({
      next: res => { this.dptos = res['data']; },
      error: err => { this.msg = err; }
    });
  }

  verifiedImgDirectory() {
    if (this.tier3.img != null) {
      (this.tier3.img.substring(1, 7) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  loadData() {
    this.formT3.reset(this.tier3);
  }

  onUpload() {
    let formData = new FormData();
    formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
    this.uploadS.uploadFile(formData).subscribe((res) => {
      this.filename = res['filename'];
      this.saveOrUpdate();
    });
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.formT3.get('img').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }

  save() {
    
    if (this.formT3.invalid) {
      return Object.values(this.formT3.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFile != null) ? this.onUpload() : this.saveOrUpdate();
    }
  }

  saveOrUpdate() {
    this.edit ? this.update(this.formT3.value.id, this.formT3.value) : this.createTier3(this.formT3.value);
    this.router.navigate(['/adm/tendencia/list']);
  }

  createTier3(t3: Tier3) {
    delete t3.id;
    t3.idtier1 = +this.idtier1;
    t3.code = t3.code.toLowerCase();
    t3.touchedBy = this.tokenStorage.getUser().nombre;
    if (this.filename) { t3.img = '/uploads/' + this.filename; }
    this.tier3Service.create(t3).subscribe({
      next: res => {
        if (res) {
          this.createRelations(res['data'].id);
          this.createNewSection(res['data'].id);
          this.utilLogservice.createLog(res['data'], 'creación', 'Lista tendencia');
        }
      },
      error: err => { console.error(err) }
    });
  }

  createRelations(newId: number) {
    const selectedRelations: Tier3Sector[] = this.formT3.get('sectors').value;
    for (let relation of selectedRelations) {
      relation.idtier3 = newId;
      relation.status = true;
      this.t3SectorService.create(relation).subscribe({
        next: res => console.log("relation created: ", res),
        error: err => console.error(err)
      });
    }
  }

  update(id: string, t3: Tier3) {
    const data = { ...t3 };
    delete t3.id;
    t3.code = t3.code.toLowerCase();
    t3.touchedBy = this.tokenStorage.getUser().nombre;
    if (this.filename) { t3.img = '/uploads/' + this.filename; }
    this.tier3Service.update(id, t3).subscribe({
      next: res => {
        if (res) {
          this.updateRelations(Number(id));
          this.utilLogservice.createLog(data, 'edición', 'Lista tendencia');
        }
      },
      error: err => { console.error(err) }
    });
  }

  updateRelations(newId: number) {

    if (this.tier3 && this.tier3.sectors) {
      console.log("id ", newId);
      const oldRelations: Tier3Sector[] = this.tier3.sectors.map((sector: Sector) => {
        return {
          idtier3: newId,
          idsector: sector.id,
          status: true
        };
      });

      this.t3SectorService.deleteRelationships(oldRelations).subscribe({
        next: delRes => {
          const newRelations: Tier3Sector[] = this.formT3.get('sectors').value;
          for (let relation of newRelations) {
            relation.idtier3 = newId;
            relation.status = true;
            this.t3SectorService.create(relation).subscribe({
              next: res => console.log("relation created: ", res),
              error: err => console.error(err)
            });
          }
        },
        error: delErr => { console.error(delErr) }
      })
    }
  }


  updateLinkSector(id: string, t3: Tier3) {
    delete t3.id;
    this.tier3Service.update(id, t3).subscribe({
      next: res => { console.log("res update: ", res) },
      error: err => { console.error(err) }
    });
  }

  campoNoValido(campo: string) {
    return this.formT3.get(campo).invalid && this.formT3.get(campo).touched;
  }

  /* Cargar data de tematic para el combo */
  tematics: any;
  getTematics() {
    this.tematicsService.getAll().subscribe({
      next: res => {
        this.tematics = res['data'];
      },
      error: err => {
        console.log(err['msg']);
      }
    });
  }


  //Agregadno para adfministracion de sectores
  getSectors() {
    this.sectorService.getAll().subscribe({
      next: res => { this.sectordata = res['data']; },
      error: err => { this.msg = err; }
    });
  }

  addSector() {
    const selectedSector = this.formT3.get('selectedSector').value;
    if (selectedSector) {
      const selectedSectors = this.formT3.get('sectors') as FormArray;
      selectedSectors.push(this.fb.group({
        idsector: selectedSector.id,
        longname: selectedSector.longname,
      }));
    }
  }

  get selectedSectorsControls() {
    return this.formT3.get('sectors') as FormArray;
  }

  sectorToDelete: number;
  showDeleteConfirmationSector = false;

  removeSector(index: number) {
    const selectedSectors = this.formT3.get('sectors') as FormArray;
    selectedSectors.removeAt(index);
  }

  triggerDeleteSectorConfirmation(i: number) {
    this.sectorToDelete = i;
    this.showDeleteConfirmationSector = true;
  }

  confirmDeleteSector() {
    this.selectedSectorsControls.removeAt(this.sectorToDelete);
    this.showDeleteConfirmationSector = false;
  }

  cancelDeleteSector() {
    this.showDeleteConfirmationSector = false;
  }

  getTier3Relations(id: string) {
    this.sectorService.getAllByIdTier3(id).subscribe({
      next: res => {
        this.tier3.sectors = res['data'];
        const selectedSectorsArray = this.fb.array([]);
        this.tier3.sectors.forEach(sectos => {
          selectedSectorsArray.push(this.fb.control(sectos));
        });
        this.formT3.setControl('sectors', selectedSectorsArray);
        this.loadDataTier3Relations();

      },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  loadDataTier3Relations() {
    while ((this.formT3.get('sectors') as FormArray).length !== 0) {
      (this.formT3.get('sectors') as FormArray).removeAt(0);
    }
    if (this.tier3.sectors && this.tier3.sectors.length > 0) {
      this.tier3.sectors.forEach((selectedSector: Sector) => {
        const selectedSectorFormGroup = this.fb.group({
          idsector: [selectedSector.id],
          longname: [selectedSector.longname]
        });
        (this.formT3.get('sectors') as FormArray).push(selectedSectorFormGroup);
      });
    }
  }

  /* Creamos una seccion como minimo con los valores por defecto*/
  section: Section = {
    id: null,
    idtier3: null,
    ideditor: null,
    order: 1,
    title: '',
    content: '',
    status: true,
    code: ''
  };

  createNewSection(idT3: number) {
    this.section.idtier3 = idT3;
    this.secS.create(this.section).subscribe(
      res => console.log("res create: ", res),
      err => console.error(err))
  }
  /* Obtener ultimos moviemientos de los usuarios en el compoente */
  getLog() {
    const term = this.activedRoute.snapshot['_routerState'].url.split('/')[2];
    const idContent = this.activedRoute.snapshot.params['id'];
    this.userLogService.getLastLogByContent(idContent, term).subscribe(
      res => { this.movesLog = res['data'] || []; },
      err => console.error(err)
    );
  }
  //Validamos el codigo de la ficha//
  statusFieldDisabled: boolean = false;
  statusFieldVisible: boolean = true;

  validateCode(): void {
    const code = this.formT3.get('code').value;

    if (!code) {
      this.codeValidationMessage = 'El campo Código no puede estar vacío.';
      return;
    }

    this.tier3Service.validateCode(code).subscribe(
      response => {
        if (response['exists']) {
          this.formT3.get('version').setValue(response['suggestedVersion']);
          this.formT3.get('isActive').setValue(false);
          this.formT3.get('isNT3').setValue(false);
          this.formT3.get('status').setValue(false);

          this.statusFieldDisabled = true;
          this.statusFieldVisible = false;

          this.codeValidationMessage = response['message'];
        } else {
          this.formT3.get('version').setValue(1);
          this.formT3.get('isActive').setValue(true);
          this.formT3.get('isNT3').setValue(true);

          this.statusFieldDisabled = false;
          this.statusFieldVisible = true;

          this.codeValidationMessage = response['message'];
        }
      },
      error => {
        console.error('Error en la validación del código:', error);
        this.codeValidationMessage = 'Ocurrió un error al validar el código.';
      }
    );
  }


}
